import * as React from 'react';

import {Body} from 'shells/typography/body';

type Props = {
    updateError: string | null | undefined;
};

export function ErrorBanner(props: Props) {
    return <Body color='error'>{props.updateError}</Body>;
}
